import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIsSection from './components/WhatIsSection';
import CategoryGrid from './components/CategoryGrid';
import HowItWorks from './components/HowItWorks';
import MoreCategories from './components/MoreCategories';
import TrustSection from './components/TrustSection';
import ArticleSection from './components/ArticleSection';
import CTASection from './components/CTASection';
import FooterSection from './components/FooterSection';
import SeoJsonLd from '@/components/base/SeoJsonLd';
import { homeSchemaOrg } from '@/mocks/schemas';

export default function Home() {
  return (
    <main>
      <SeoJsonLd data={homeSchemaOrg} />
      <Navbar />
      <Hero />
      <WhatIsSection />
      <CategoryGrid />
      <HowItWorks />
      <MoreCategories />
      <TrustSection />
      <ArticleSection />
      <CTASection />
      <FooterSection />
    </main>
  );
}